import { render, staticRenderFns } from "./scriptwriterInfo.vue?vue&type=template&id=63876de4&scoped=true&"
import script from "./scriptwriterInfo.vue?vue&type=script&lang=js&"
export * from "./scriptwriterInfo.vue?vue&type=script&lang=js&"
import style0 from "./scriptwriterInfo.vue?vue&type=style&index=0&id=63876de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63876de4",
  null
  
)

export default component.exports